import React from 'react';
import { Activity, Download, Trash2 } from 'lucide-react';
import { useAuth, ROLES } from '../context/AuthContext';
import { useCRM } from '../context/CRMContext';

const Activities = () => {
  const { user } = useAuth();
  const { activities, clearActivities, deleteActivity } = useCRM();

  return (
    <div className="animate-fade-in">
      <div style={{ marginBottom: '2rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <h1>Registro de Actividades</h1>
          <p className="text-muted">Historial de auditoría para toda la organización.</p>
        </div>

        {/* Action Button: Solo para Admin */}
        {user?.role === ROLES.ADMIN && (
          <div style={{ display: 'flex', gap: '1rem' }}>
            <button className="btn" onClick={clearActivities} style={{ padding: '0.5rem 1rem', border: '1px solid var(--danger)', color: 'var(--danger)' }}>
              <Trash2 size={18} />
              Limpiar Todo
            </button>
            <button className="btn" style={{ padding: '0.5rem 1rem', border: '1px solid var(--border)' }}>
              <Download size={18} />
              Exportar a CSV
            </button>
          </div>
        )}
      </div>

      <div className="card" style={{ padding: '1.5rem', display: 'flex', flexDirection: 'column', gap: '1.5rem' }}>
        {activities.length === 0 ? (
          <p className="text-muted" style={{ textAlign: 'center', padding: '2rem 0' }}>No hay actividades registradas.</p>
        ) : (
          activities.map((act) => (
          <div key={act.id} style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem', paddingBottom: '1rem', borderBottom: '1px solid var(--border)' }}>
            <div className="avatar" style={{ backgroundColor: 'var(--primary)', width: '32px', height: '32px' }}>
              <Activity size={16} />
            </div>
            <div style={{ flex: 1 }}>
              <p style={{ fontWeight: 500, color: 'var(--text-main)', marginBottom: '0.25rem' }}>
                {act.text}
              </p>
              <span className="text-muted" style={{ fontSize: '0.85rem' }}>
                {act.time}
              </span>
            </div>

            {/* Delete Audit Log Action: Solo Admin */}
            {user?.role === ROLES.ADMIN && (
              <button className="action-btn" title="Borrar registro (Solo Admin)" onClick={() => deleteActivity(act.id)}>
                <Trash2 size={16} color="var(--danger)" />
              </button>
            )}
          </div>
        )))}
      </div>
    </div>
  );
};

export default Activities;
